import type { TIrrigationZoneEmitter } from 'stores/fieldAssetStore/helperTypes'
import { mapApiEmitterTypeToLabel } from 'utils/mapApiEmitterTypeToLabel'

export const sortByEmitterType = (a: TIrrigationZoneEmitter, b: TIrrigationZoneEmitter) => {
  if (a.emitterType === b.emitterType) return 0

  return mapApiEmitterTypeToLabel(a.emitterType) > mapApiEmitterTypeToLabel(b.emitterType) ? 1 : -1
}
